const Css = {
  TimeScale(width, slideBtnWidth){
    return {
      width: width + "px",
      height: "30px",
      position: "relative",
      borderBottom: "2px solid #121212",
      float: "left",
      marginLeft: slideBtnWidth + "px",
      userSelect: "none",
      padding: "0 3px"
    }
  },
  ScaleItem(obj, isLastOne, isFirstOne, initScaleLeft, left){    
    let sty = {
      color: "#888888",
      fontSize: "11px",
      float: "left",
      transition: "all 0.05s linear",
      position: "absolute",
      left: left + "px",
    }
    if(isLastOne){
      sty.width = (obj.deciSpace - initScaleLeft) + "px";
    }else{
      sty.width = obj.space + "px";
    }
    if(isFirstOne){
      sty.left = initScaleLeft + "px";
    }
    return sty;
  },
  ItemSp1(isLastOne, lastSpanMarginLeft){
    let sty = {
      position: "absolute",
      display: "inline-block",
      marginTop: "6px",
      transition: "all 0.05s linear",
    }
    if(isLastOne){
      sty.marginLeft = "-" + lastSpanMarginLeft + "px";
    }
    return sty;
  },
  ItemSp2(isLastOne){
    let sty = {
      display: "inline-block",
      width: "1px",
      height: "6px",
      backgroundColor: " #888888",
      margin: "24px 0 0 0px"
    };
    if(isLastOne){
      sty.margin = "24px 0 0 0";
    }
    return sty;
  }
}

export default Css;